/** API hata zarfı. Akış `code` ile yürür; kullanıcı metni `message` alanındadır. */
export class ApiError extends Error {
  readonly status: number
  readonly code: string
  readonly details: unknown
  readonly warning: unknown

  constructor(status: number, code: string, message: string, details?: unknown, warning?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.details = details
    this.warning = warning
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError
}

/** Ağ hatası, zaman aşımı gibi yanıt alınamayan durumlar. */
export const NETWORK_ERROR = 'NETWORK_ERROR'

/** `error: { Limit: "Limit, 100 veya daha az olmalıdır" }` gibi alan mesajlarını düz listeye çevirir. */
export function validationMessages(details: unknown): string[] {
  if (details == null || details === '') return []
  if (typeof details === 'string') {
    const text = details.trim()
    return text ? [text] : []
  }
  if (typeof details === 'number' || typeof details === 'boolean') return [String(details)]
  if (Array.isArray(details)) return details.flatMap(validationMessages)
  if (typeof details !== 'object') return []

  const messages: string[] = []
  for (const value of Object.values(details as Record<string, unknown>)) {
    if (typeof value === 'string' && value.trim()) {
      messages.push(value.trim())
      continue
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        if (typeof item === 'string' && item.trim()) messages.push(item.trim())
        else messages.push(...validationMessages(item))
      }
      continue
    }
    if (value && typeof value === 'object') messages.push(...validationMessages(value))
  }
  return messages
}
